import { render, staticRenderFns } from "./CoursewareSearchResults.vue?vue&type=template&id=0c83bf4e&"
import script from "./CoursewareSearchResults.vue?vue&type=script&lang=js&"
export * from "./CoursewareSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports